import React from 'react';

const SocialMediaIcon = ({smLink, icon}) => {
    return (
        <span className='mr-2 lg:mr-4'>
            <a href={smLink} target="_blank" rel="noopener noreferrer">
                <img className='lg:h-10 lg:w-10 h-8 w-8 cursor-pointer' src={icon}></img>
            </a>
        </span>
    );
};

export default SocialMediaIcon;